import React from 'react';
import { Icon } from './Icon.js';
export const IconEyeFilled = ({ ...props }) => {
    return (React.createElement(Icon, { size: "20px", ...props },
        React.createElement("path", { d: "m17.511,8.196c-.877-1.562-3.365-5.196-7.511-5.196s-6.634,3.634-7.496,5.17c-.663,1.103-.668,2.525-.016,3.633.663,1.251,3.107,5.196,7.512,5.196,4.146,0,6.634-3.634,7.496-5.17.668-1.111.668-2.548.015-3.634Zm-7.511,4.804c-1.657,0-3-1.343-3-3s1.343-3,3-3,3,1.343,3,3-1.343,3-3,3Z", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconEyeFilled.js.map